import Vue from 'vue';
import Buefy from 'buefy';
import vSelect from 'vue-select';
import VueAutosuggest from 'vue-autosuggest';
import VueFragment from 'vue-fragment';
import { VueMasonryPlugin } from 'vue-masonry';

import 'vue-datetime/dist/vue-datetime.css';
import 'vue-select/dist/vue-select.css';
import '@creativebulma/bulma-divider/dist/bulma-divider.css';
// Import as early as possible as this will initiate firebase
import { auth } from './firebase';

import App from './App';
import con from './store/mutationTypes';
import { initSearchClient } from './utils/search';
import router from './router';
import store from './store';
import * as GeneralComponents from './ui/general';

Vue.config.productionTip = false;

/**
 * Initializes algolia search client and adds it as Vue instance property so
 * it can be access from all components.
 * (Access it in components as `this.$searchClient`)
 */
initSearchClient();

// Add custom vue directives here

// Autofocus input on every insert
Vue.directive('focus', {
  inserted: function(el, binding) {
    binding.value && el.focus();
  }
});
// Autofocus buefy input on every insert
Vue.directive('bfocus', {
  inserted: function(el, binding, vnode) {
    binding.value && vnode.componentInstance.focus();
  }
});

/**
 * All external Vue libraries are registered with Vue here except for
 * `Vuex` and `VueRouter`.
 */
Vue.use(Buefy);
Vue.use(VueAutosuggest);
Vue.use(VueFragment.Plugin);
Vue.use(VueMasonryPlugin);

// Registering external components
Vue.component('v-select', vSelect);

// Registering general components
for (let x in GeneralComponents) {
  Vue.component(x, GeneralComponents[x]);
}

let app = null;

auth.onAuthStateChanged(() => {
  store.commit(con.UPDATE_APP_STATE_NAMESPACED, { isFirebaseLoaded: true });
  document.getElementById('app-loading').classList.add('remove');

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
